/* digitallspace — global interactions for all Dawn pages */
(function () {
  document.documentElement.classList.add('ds-js');
  var fine = window.matchMedia('(pointer:fine)').matches;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = window.Shopify && window.Shopify.designMode;

  /* ---------- smooth inertial scroll ---------- */
  var lenis = null;
  if (!reduced && !designMode && typeof Lenis !== 'undefined') {
    lenis = new Lenis({
      duration: 1.4,
      easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
      smoothWheel: true
    });
    lenis.on('scroll', onScroll);
    requestAnimationFrame(function raf(time) { lenis.raf(time); requestAnimationFrame(raf); });

    /* pause smooth scroll while Dawn locks the body (drawers, modals) */
    var lockObserver = new MutationObserver(function () {
      var locked =
        document.documentElement.classList.contains('overflow-hidden') ||
        document.body.classList.contains('overflow-hidden') ||
        document.documentElement.classList.contains('overflow-hidden-desktop') ||
        document.documentElement.classList.contains('overflow-hidden-tablet') ||
        document.documentElement.classList.contains('overflow-hidden-mobile');
      if (locked) lenis.stop(); else lenis.start();
    });
    lockObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    lockObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  } else {
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- top fade + back-to-top ---------- */
  var topFade = document.querySelector('.ds-top-fade');
  var toTop = document.querySelector('.ds-to-top');
  function onScroll() {
    var y = window.scrollY;
    if (topFade) topFade.classList.toggle('is-on', y > 40);
    if (toTop) toTop.classList.toggle('show', y > window.innerHeight * 0.9);
  }
  if (toTop) {
    toTop.addEventListener('click', function () {
      if (lenis) lenis.scrollTo(0); else window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ---------- soft reveals for cards and grid items ---------- */
  if (!reduced && 'IntersectionObserver' in window) {
    var items = document.querySelectorAll(
      '.card-wrapper, .multicolumn-list__item, .article-card-wrapper, .collection-list__item'
    );
    if (items.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('ds-in'); io.unobserve(en.target); }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -5% 0px' });
      items.forEach(function (el, i) {
        el.classList.add('ds-rv');
        el.style.setProperty('--ds-d', (i % 4) * 0.08 + 's');
        io.observe(el);
      });
    }
  }

  onScroll();
})();

/* ---------- designer effects: page transition + magnetic buttons ---------- */
(function(){
  var fine = window.matchMedia('(pointer:fine)').matches;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- tilt product cards ---------- */
  if (fine && !reduced) {
    document.querySelectorAll('.card').forEach(function(el){
      el.addEventListener('mousemove', function(e){
        var r = el.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        el.style.transform = 'perspective(800px) rotateX(' + (-py * 4.5).toFixed(2) + 'deg) rotateY(' + (px * 4.5).toFixed(2) + 'deg)';
      });
      el.addEventListener('mouseleave', function(){ el.style.transform = ''; });
    });
    /* catalogue and "You may also like" cards: the homepage's tilt
       (ds-home.js), lift included. Delegated from the document because the
       recommendations are fetched and inserted after load. */
    var tilted = null;
    document.addEventListener('mousemove', function(e){
      var el = e.target.closest ? e.target.closest('.asset-cover') : null;
      if (tilted && tilted !== el) { tilted.style.transform = ''; tilted = null; }
      if (!el) return;
      tilted = el;
      var r = el.getBoundingClientRect();
      var px = (e.clientX - r.left) / r.width - 0.5;
      var py = (e.clientY - r.top) / r.height - 0.5;
      el.style.transform = 'perspective(800px) rotateX(' + (-py * 5).toFixed(2) + 'deg) rotateY(' + (px * 5).toFixed(2) + 'deg) translateY(-6px)';
    }, { passive: true });
    document.documentElement.addEventListener('mouseleave', function(){ if (tilted) { tilted.style.transform = ''; tilted = null; } });
  }

  /* ---------- blur-up image load ---------- */
  if (!reduced) {
    document.querySelectorAll('.card__media img, .media > img, .product__media img, .product-media-container img, .asset-img-1').forEach(function(img){
      img.classList.add('ds-blurup');
      if (img.complete && img.naturalWidth) img.classList.add('ds-loaded');
      else img.addEventListener('load', function(){ img.classList.add('ds-loaded'); }, { once: true });
    });
  }

  /* ---------- add-to-cart micro-interaction (pulse cart icon) ---------- */
  var cartBubble = document.getElementById('cart-icon-bubble');
  if (cartBubble && !reduced && 'MutationObserver' in window) {
    var cartObs = new MutationObserver(function(){
      cartBubble.classList.remove('ds-cart-pulse');
      void cartBubble.offsetWidth;
      cartBubble.classList.add('ds-cart-pulse');
    });
    cartObs.observe(cartBubble, { childList: true, subtree: true, characterData: true });
  }

  if (fine && !reduced) {
    var magnets = [].slice.call(document.querySelectorAll('.button'));
    if (magnets.length) {
      var PAD = 45, PULL = 0.1;                 /* gentler pull (was 0.18) */
      var mmx = 0, mmy = 0, moved = false, rectsDirty = true, rects = [];
      /* cache rects; only re-read layout when it can actually have changed */
      function measure(){ for (var i = 0; i < magnets.length; i++) rects[i] = magnets[i].getBoundingClientRect(); rectsDirty = false; }
      window.addEventListener('mousemove', function(e){ mmx = e.clientX; mmy = e.clientY; moved = true; }, { passive: true });
      window.addEventListener('scroll', function(){ rectsDirty = true; }, { passive: true });
      window.addEventListener('resize', function(){ rectsDirty = true; }, { passive: true });
      (function magnetLoop(){
        if (moved) {
          if (rectsDirty) measure();
          var vh = window.innerHeight, active = false;
          for (var i = 0; i < magnets.length; i++) {
            var b = magnets[i], r = rects[i];
            if (r.bottom < -60 || r.top > vh + 60) { if (b.style.transform) b.style.transform = ''; continue; }
            var cx = r.left + r.width / 2, cy = r.top + r.height / 2;
            var dx = mmx - cx, dy = mmy - cy;
            var range = Math.max(r.width, r.height) / 2 + PAD;
            var dist = Math.sqrt(dx * dx + dy * dy);
            if (dist < range) {
              var pull = PULL * (1 - dist / range);
              b.style.transform = 'translate(' + (dx * pull).toFixed(1) + 'px,' + (dy * pull).toFixed(1) + 'px)';
              active = true;
            } else if (b.style.transform) {
              b.style.transform = '';
            }
          }
          /* nothing displaced and cursor left every button: idle until next move */
          moved = active;
        }
        requestAnimationFrame(magnetLoop);
      })();
    }
  }
})();

/* ---------- prefetch internal pages on hover (instant navigation) ---------- */
(function(){
  var seen={}, n=0;
  function prefetch(url){
    if(seen[url]||n>12)return; seen[url]=1; n++;
    var l=document.createElement('link'); l.rel='prefetch'; l.href=url;
    document.head.appendChild(l);
  }
  function onHint(e){
    var a=e.target&&e.target.closest&&e.target.closest('a'); if(!a)return;
    var h=a.getAttribute('href');
    if(!h||h.charAt(0)==='#'||h.indexOf('mailto:')===0||h.indexOf('tel:')===0)return;
    if(a.target==='_blank'||a.hasAttribute('download'))return;
    if(a.hostname&&a.hostname!==location.hostname)return;
    if(a.href===location.href)return;
    prefetch(a.href);
  }
  document.addEventListener('mouseover',onHint,{passive:true});
  document.addEventListener('touchstart',onHint,{passive:true});
})();


/* ---------- letter-assemble text auto (site-wide, extends .ds-split) ---------- */
(function(){
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SEL = 'h1, h2, h3, .h0, .h1, .h2, .h3, blockquote, .card__heading';
  /* .product__title is excluded on purpose: the shimmer on it is a gradient
     clipped to the text, and splitting the heading into per-letter spans
     breaks that clip — the glyphs end up transparent with nothing behind. */
  var SKIP = '.button, .price, .quantity, form, .cart-drawer, cart-notification, predictive-search, .header__heading-link, .header__inline-menu, .header__menu-item, .announcement-bar, .product__title, [data-nosplit]';
  function letterize(node){
    var chars=[];
    [].slice.call(node.childNodes).forEach(function(n){
      if(n.nodeType===3){
        var frag=document.createDocumentFragment();
        n.textContent.split(/(\s+)/).forEach(function(part){
          if(part==='')return;
          if(/^\s+$/.test(part)){frag.appendChild(document.createTextNode(part));return;}
          var word=document.createElement('span');word.className='ds-word';
          [].forEach.call(part,function(ch){var s=document.createElement('span');s.className='ds-char';s.textContent=ch;word.appendChild(s);chars.push(s);});
          frag.appendChild(word);
        });
        node.replaceChild(frag,n);
      } else if(n.nodeType===1){
        if(n.tagName==='BR')return;
        if(n.classList&&n.classList.contains('ds-char'))return;
        chars=chars.concat(letterize(n));
      }
    });
    return chars;
  }
  var targets=[].slice.call(document.querySelectorAll(SEL)).filter(function(el){
    if(el.classList.contains('ds-split'))return false;
    if(SKIP&&el.closest(SKIP))return false;
    if(el.querySelector('img,svg,input,select,textarea,button,iframe,video'))return false;
    var t=(el.textContent||'').replace(/\s+/g,' ').trim();
    if(!t||t.length>160)return false;
    return true;
  });
  if(!targets.length)return;
  if(reduced){ targets.forEach(function(el){el.classList.add('ds-split','in');}); return; }
  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(en){ if(en.isIntersecting){en.target.classList.add('in');io.unobserve(en.target);} });
  },{threshold:0.12, rootMargin:'0px 0px -6% 0px'});
  targets.forEach(function(el){
    var chars=letterize(el);
    chars.forEach(function(c,i){ c.style.animationDelay=Math.min(i*0.02,0.5).toFixed(3)+'s'; });
    el.classList.add('ds-split');
    el.style.visibility='visible';
    io.observe(el);
  });
})();

/* ---------- smooth block fade for paragraphs (light blur) ---------- */
(function(){
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SEL = '.rte p, .rte li, .banner__text';
  var SKIP = '.button, .price, form, .cart-drawer, cart-notification, [data-nosplit]';
  var targets=[].slice.call(document.querySelectorAll(SEL)).filter(function(el){
    if(el.classList.contains('ds-split')||el.classList.contains('ds-fade'))return false;
    if(SKIP&&el.closest(SKIP))return false;
    var t=(el.textContent||'').replace(/\s+/g,' ').trim();
    if(t.length<20)return false;
    return true;
  });
  if(!targets.length)return;
  if(reduced){ targets.forEach(function(el){el.classList.add('ds-fade','in');}); return; }
  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(en){ if(en.isIntersecting){en.target.classList.add('in');io.unobserve(en.target);} });
  },{threshold:0.06, rootMargin:'0px 0px -4% 0px'});
  targets.forEach(function(el){ el.classList.add('ds-fade'); io.observe(el); });
  /* Product page: the first line of the description rises in straight away,
     just after the title and button, instead of waiting to be scrolled into
     view. On a phone it sits at the very bottom of the first screen, and
     until it appeared the page looked as if it ended at the price. The rest
     of the description still comes in on scroll. */
  var firstLine = document.querySelector('.product__description .ds-fade');
  if(firstLine){
    io.unobserve(firstLine);
    firstLine.style.animationDelay = '.35s';   /* the rise runs from opacity 0, so no frame wait is needed */
    firstLine.classList.add('in');
  }
})();


/* ===== cursor ring (rogi-style) ===== */
(function(){
  if(!window.matchMedia||!window.matchMedia('(pointer:fine)').matches)return;
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  var dot=document.createElement('div');dot.className='ds-cursor';dot.appendChild(document.createElement('i'));
  (document.body||document.documentElement).appendChild(dot);
  document.documentElement.classList.add('ds-cursor-on');
  var x=window.innerWidth/2,y=window.innerHeight/2,tx=x,ty=y,shown=false;
  window.addEventListener('mousemove',function(e){tx=e.clientX;ty=e.clientY;
    if(!shown){shown=true;dot.style.opacity='1';}
    var t=e.target;
    dot.classList.toggle('is-hover',!!(t&&t.closest&&t.closest('a,button,.btn,summary,[role=button]')));
  },{passive:true});
  document.addEventListener('mouseleave',function(){dot.style.opacity='0';shown=false;});
  (function loop(){x+=(tx-x)*0.2;y+=(ty-y)*0.2;
    dot.style.transform='translate3d('+x.toFixed(2)+'px,'+y.toFixed(2)+'px,0) translate(-50%,-50%)';
    requestAnimationFrame(loop);})();
})();

/* ===== header word-roll on hover ===== */
(function(){
  var els=document.querySelectorAll('.header__menu-item');
  [].forEach.call(els,function(el){
    var host=el;
    if(el.children.length===1&&el.firstElementChild.tagName==='SPAN'&&!el.firstElementChild.children.length){host=el.firstElementChild;}
    if(host.children.length)return;
    var txt=(host.textContent||'').trim(); if(!txt)return;
    host.textContent='';
    var roll=document.createElement('span');roll.className='ds-roll';
    var col=document.createElement('span');col.className='ds-roll-col';
    var a=document.createElement('span');a.textContent=txt;
    var b=document.createElement('span');b.setAttribute('aria-hidden','true');b.setAttribute('data-t',txt);
    col.appendChild(a);col.appendChild(b);roll.appendChild(col);host.appendChild(roll);
  });
})();


/* ===== cart: require Terms & Policy consent before checkout =====
   Two jobs: gate the checkout button, and record the consent on the cart so it
   lands on the order. The hidden input rides along with the cart form POST (so
   it survives an instant click), and /cart/update.js stores it server-side (so
   it survives navigating away and coming back). */
(function(){
  var ATTR = 'Terms and Refund Policy consent';   /* named for what the box says */
  function scopeOf(el){ return el.closest('cart-drawer, .cart__footer, #main-cart-footer, form') || document; }

  function sync(box){
    var scope=scopeOf(box);
    var btn=scope.querySelector('.cart__checkout-button, [name="checkout"]');
    if(btn) btn.disabled = !box.checked;
  }

  function stamp(){
    /* e.g. "Accepted 2026-09-04T18:22:11Z" — readable in the order admin */
    return 'Accepted ' + new Date().toISOString().replace(/\.\d{3}Z$/, 'Z');
  }

  function record(box){
    var value = box.checked ? stamp() : '';
    /* keep every copy of the hidden field in step (cart page + drawer) */
    [].forEach.call(document.querySelectorAll('.ds-terms__record'), function(input){
      input.value = value;
    });
    if(!window.fetch) return;
    var payload = {};
    payload[ATTR] = value;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: payload })
    }).catch(function(){});
  }

  document.addEventListener('change', function(e){
    var t=e.target;
    if(t && t.classList && t.classList.contains('ds-terms__input')){ sync(t); record(t); }
  });

  function init(){
    [].forEach.call(document.querySelectorAll('.ds-terms__input'), function(box){
      /* consent already given for this cart — restore the tick rather than ask twice */
      var recordInput=scopeOf(box).querySelector('.ds-terms__record');
      if(recordInput && recordInput.value && !box.checked) box.checked = true;
      sync(box);
    });
  }
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();

/* ===== one copy per product (digital goods) ===== */
(function(){
  if(!window.fetch||window.__dsOnePer)return; window.__dsOnePer=true;
  var _fetch=window.fetch;
  /* only act on same-origin cart/add requests, matched by path (never on a URL
     that merely mentions /cart/add inside a query string) */
  function isCartAdd(url){
    try{ var u=new URL(url, location.origin);
      return u.origin===location.origin && /\/cart\/add(\.js)?$/.test(u.pathname); }
    catch(e){ return /\/cart\/add(\.js)?(\?|$)/.test(String(url||'')); }
  }
  function reqId(input,init){
    try{
      var body=(init&&init.body)||(input&&input.body);
      if(!body)return null;
      if(typeof body==='string'){
        if(body.charAt(0)==='{')return String(JSON.parse(body).id||'');
        var m=body.match(/(?:^|&)id=([^&]+)/);
        return m?decodeURIComponent(m[1]):null;
      }
      if(typeof FormData!=='undefined'&&body instanceof FormData)return String(body.get('id')||'');
    }catch(e){}
    return null;
  }
  window.fetch=function(input,init){
    var args=arguments;
    var url=typeof input==='string'?input:((input&&input.url)||'');
    if(!isCartAdd(url))return _fetch.apply(window,args);
    var id=reqId(input,init);
    if(!id)return _fetch.apply(window,args);
    return _fetch('/cart.js',{headers:{Accept:'application/json'}})
      .then(function(r){return r.json();})
      .then(function(cart){
        var dup=(cart.items||[]).some(function(i){return String(i.variant_id)===String(id);});
        if(!dup)return _fetch.apply(window,args);
        var msg={status:422,message:'Already in cart',
          description:'Already in your cart — one copy is enough.'};
        return new Response(JSON.stringify(msg),{status:422,headers:{'Content-Type':'application/json'}});
      })
      .catch(function(){return _fetch.apply(window,args);});
  };
  /* safety net: never allow quantity > 1 (corrects every affected line at once) */
  function normalize(){
    _fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json();}).then(function(cart){
      var over=(cart.items||[]).filter(function(i){return i.quantity>1;});
      if(!over.length)return;
      var updates={};
      over.forEach(function(i){updates[i.variant_id]=1;});
      _fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},
        body:JSON.stringify({updates:updates})}).then(function(){
          if(location.pathname.indexOf('/cart')===0)location.reload();
        });
    }).catch(function(){});
  }
  if(document.readyState!=='loading')normalize();else document.addEventListener('DOMContentLoaded',normalize);
})();

/* ===== "Buy now": add to cart, then go to the cart (never straight to checkout) ===== */
(function(){
  document.addEventListener('click', function(e){
    var btn = e.target && e.target.closest && e.target.closest('.ds-buy-now');
    if(!btn) return;
    e.preventDefault();
    var cartUrl = btn.getAttribute('data-cart-url') || '/cart';
    var form = btn.closest('form[action*="/cart/add"]');
    if(!form){ window.location.href = cartUrl; return; }
    if(btn.hasAttribute('aria-busy')) return;
    btn.setAttribute('aria-busy','true');
    btn.disabled = true;
    var data = new FormData(form);
    data.delete('sections'); data.delete('sections_url');
    fetch('/cart/add.js', { method:'POST', body:data, headers:{ Accept:'application/json' } })
      .then(function(){ window.location.href = cartUrl; })
      .catch(function(){ window.location.href = cartUrl; });
  });
})();

/* ===== burger: the black fill grows out of the burger itself ===== */
/* ds-global.css centres the clip-path circle on --ds-cx/--ds-cy, the burger's
   centre in the panel's own coordinates. A closed <details> gives the panel no
   layout to measure, so this works from the header instead: the panel hangs
   from the bottom of .header-wrapper's padding box at its left edge. Set on
   load and on resize, so the closed circle is already sitting under the
   burger when Dawn starts the transition. */
(function(){
  var sum = document.querySelector('header-drawer summary');
  var drawer = document.getElementById('menu-drawer');
  var wrap = drawer && drawer.closest('.header-wrapper');
  if(!sum || !drawer || !wrap) return;
  function aim(){
    var s = sum.getBoundingClientRect(), w = wrap.getBoundingClientRect();
    if(!s.width) return;                       // burger hidden (desktop inline menu)
    var top = w.bottom - (parseFloat(getComputedStyle(wrap).borderBottomWidth) || 0);
    drawer.style.setProperty('--ds-cx', (s.left + s.width / 2 - w.left).toFixed(1) + 'px');
    drawer.style.setProperty('--ds-cy', (s.top + s.height / 2 - top).toFixed(1) + 'px');
  }
  aim();
  var t; window.addEventListener('resize', function(){ clearTimeout(t); t = setTimeout(aim, 150); });
  sum.addEventListener('click', aim, true);    // the sticky header may have moved
})();
